/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kindnimmtnichtteilstand4Inputs */

const de__field_kindnimmtnichtteilstand4 = /** @type {(inputs: _Field_Kindnimmtnichtteilstand4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kind nimmt nicht teil Stand`)
};

/**

* @param {_Field_Kindnimmtnichtteilstand4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kindnimmtnichtteilstand4 = /** @type {((inputs?: _Field_Kindnimmtnichtteilstand4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kindnimmtnichtteilstand4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kindnimmtnichtteilstand4(inputs)
});
export { _field_kindnimmtnichtteilstand4 as "_field_kindNimmtNichtTeilStand" }